import { CoreIcon } from '../core-icon';
import playCircleFillSVG from '../../assets/icons/play-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const PlayCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={playCircleFillSVG} {...props} />;
};
